export const scrollTopButton = () => {
  const button = document.getElementById('js-pagetop');
  const container = document.getElementById('pagetop');
  if (!container) return;

  const options = {
    rootMargin: '20% 0px -120% 0px',
  };

  const callback = (entries: IntersectionObserverEntry[]) => {
    const showButton = () => button?.removeAttribute('aria-hidden');
    const hideButton = () => button?.setAttribute('aria-hidden', 'true');

    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        showButton();
      } else {
        hideButton();
      }
    });
  };

  const observer = new IntersectionObserver(callback, options);
  observer.observe(container);
};
